import { Form } from 'antd'
import cls from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Editor } from '@/components'
import { removeHtmlTag } from '@/utils/remove-html-tag'

import { Customer } from '../customer.schema'

export const FieldChangedReasonFormItem: React.FC<{
  field: string
  customer?: Customer
  fieldsChanged: {
    [key: string]: boolean
  }
}> = ({ field, customer, fieldsChanged }) => {
  const { t } = useTranslation()

  return fieldsChanged[field] || customer?.[`${field}ChangeReason`] ? (
    <Form.Item
      label={t('customer.detail.changeReason', { field: t(`customer.detail.${field}`) })}
      tooltip={t('customer.form.field.forbidden.tooltip')}
      valuePropName='content'
      trigger='onChange'
      name={`${field}ChangeReason`}
      rules={[
        {
          required: true,
          validator: async (_, value) =>
            !removeHtmlTag(value).trim()
              ? Promise.reject(
                  `${t('customer.detail.changeReason', { field: t(`customer.detail.${field}`) })}是必选填项!`
                )
              : Promise.resolve(),
        },
      ]}
    >
      <Editor
        editable={fieldsChanged[field]}
        disableAutoSaveStyle
        className={cls('editorBorder', { editorDisabled: !fieldsChanged[field] })}
      />
    </Form.Item>
  ) : null
}
